import { Operator } from './operator.model';

export type CarrierCodes =
  | 'Vueling'
  | 'Iberia'
  | 'IberiaExpress'
  | 'AirNostrum'
  | 'MelAir'
  | 'GetJet'
  | 'British'
  | 'AerLingus'
  | 'AirHub'
  | 'QatarAirways'
  | 'BritishAirways'
  | 'LATAM'
  | 'AmericanAirlines'
  | 'RoyalJordanian'
  | 'CathayPacific'
  | 'DragonAir'
  | 'Corsair'
  | 'SingaporeAirlines'
  | 'AsianaAirlines'
  | 'Emirates'
  | 'HainanAirlines'
  | 'AirChina'
  | 'JapanAirlines'
  | 'EtihadAirways'
  | 'TurkishAirlines';

export type AbbreviatedCarrierCodes =
  | 'VY'
  | 'IB'
  | 'I2'
  | 'YW'
  | 'MA'
  | 'GW'
  | 'BA'
  | 'EI'
  | 'RE'
  | 'QR'
  | 'LA'
  | 'AA'
  | 'RJ'
  | 'CX'
  | 'KA'
  | 'SS'
  | 'SQ'
  | 'OZ'
  | 'EK'
  | 'HU'
  | 'CA'
  | 'JL'
  | 'EY'
  | 'TK';

export const CarrierCodesValue: Record<CarrierCodes, AbbreviatedCarrierCodes> = {
  Vueling: 'VY',
  Iberia: 'IB',
  IberiaExpress: 'I2',
  AirNostrum: 'YW',
  MelAir: 'MA',
  GetJet: 'GW',
  British: 'BA',
  AerLingus: 'EI',
  AirHub: 'RE',
  QatarAirways: 'QR',
  BritishAirways: 'BA',
  LATAM: 'LA',
  AmericanAirlines: 'AA',
  RoyalJordanian: 'RJ',
  CathayPacific: 'CX',
  DragonAir: 'KA',
  Corsair: 'SS',
  SingaporeAirlines: 'SQ',
  AsianaAirlines: 'OZ',
  Emirates: 'EK',
  HainanAirlines: 'HU',
  AirChina: 'CA',
  JapanAirlines: 'JL',
  EtihadAirways: 'EY',
  TurkishAirlines: 'TK'
};

export const CodeshareCarrierCode: AbbreviatedCarrierCodes[] = ['IB', 'BA'];

export const CarriersInfo: Record<AbbreviatedCarrierCodes, Operator> = {
  VY: {
    operatorIcon: 'ds-icon-logo-primary-default',
    operatorName: 'Vueling'
  },
  RE: {
    operatorName: 'AirHub'
  },
  GW: {
    operatorName: 'GetJet'
  },
  BA: {
    operatorIcon: 'ds-icon-logo-british',
    operatorName: 'British Airways'
  },
  IB: {
    operatorIcon: 'ds-icon-logo-iberia',
    operatorName: 'Iberia'
  },
  EI: {
    operatorName: 'Aer Lingus'
  },
  YW: {
    operatorName: 'Air Nostrum'
  },
  I2: {
    operatorIcon: 'ds-icon-logo-iberia',
    operatorName: 'Iberia Express'
  },
  MA: {
    operatorName: 'Mel Air'
  },
  QR: {
    operatorName: 'Qatar Airways'
  },
  LA: {
    operatorName: 'LATAM'
  },
  AA: {
    operatorName: 'American Airlines'
  },
  RJ: {
    operatorName: 'Royal Jordanian'
  },
  CX: {
    operatorName: 'Cathay Pacific'
  },
  KA: {
    operatorName: 'DragonAir'
  },
  SS: {
    operatorName: 'Corsair'
  },
  SQ: {
    operatorName: 'Singapore Airlines'
  },
  OZ: {
    operatorName: 'Asiana Airlines'
  },
  EK: {
    operatorName: 'Emirates'
  },
  HU: {
    operatorName: 'Hainan Airlines'
  },
  CA: {
    operatorName: 'Air China'
  },
  JL: {
    operatorName: 'Japan Airlines'
  },
  EY: {
    operatorName: 'Etihad Airways'
  },
  TK: {
    operatorName: 'Turkish Airlines'
  }
};

export const UnavailableIcon = 'unavailable-icon';
export const OperatedByLabel = 'booking_details_component.flight_journey_summary_component.operated_by';
